<mat-form-field [appearance]="appearance()" [class]="class()" class="flex-1">
  <mat-label>{{label()}}</mat-label>
  <div matSuffix="" class="flex items-center">
    @if (isLoadingCountries === true) {
      <mat-spinner diameter="14" class="mx2"></mat-spinner>
    }
  </div>
  <input [formControl]="control()" type="text" matInput="" [matAutocomplete]="countryAutoComplete" [required]="required() !== false" [attr.cdkFocusInitial]="focus() !== false ? 'true' : null" autocomplete="off">
  <mat-autocomplete autoActiveFirstOption="" #countryAutoComplete="matAutocomplete" [displayWith]="displayWithCountry">
    @if (required() === false) {
      <mat-option [value]="null">
        <span translate="">None</span>
      </mat-option>
    }
    @for (country of countriesFiltered; track country) {
      <mat-option [value]="country">
        {{country.name}}
      </mat-option>
    }
  </mat-autocomplete>
</mat-form-field>